import { defineStore } from "pinia"

export type TiposDeStatus = "sucesso" | "erro" | "aguardando" | "importando"

interface EstadosImportacoes {
  arquivos: {
    [key: string]: Array<File>
  },
  estadoDoArquivo: {
    [key: string]: Array<TiposDeStatus>
  },
  estaCarregando: {
    [key: string]: boolean
  }
}

export const usarImportacoesStore = defineStore("importacoes", {
  state: (): EstadosImportacoes => ({
    arquivos: {},
    estadoDoArquivo: {},
    estaCarregando: {},
  }),
  getters: {
    arquivosDoImportador: (state) => (importador: string): Array<File> => {
      return state.arquivos[importador]
    },
    estadoDoArquivoImportador: (state) => (importador: string): Array<TiposDeStatus> => {
      return state.estadoDoArquivo[importador]
    },
    possuiArquivosSendoImportados: (state) => (importador: string): boolean => {
      return state.arquivos[importador] && state.arquivos[importador].length > 0
    }
  },
  actions: {
    async adicionarArquivo(arquivo: File, importador: string) {
      const indiceDeEstado = "aguardando"
      if (!this.arquivos[importador]) {
        this.arquivos[importador] = []
      }

      this.arquivos[importador].push(arquivo)
      this.estadoDoArquivo[importador].push(indiceDeEstado)
    },
  }
})
